export default __webpack_public_path__ + "static/media/76.d7857f07.gif";